<template>
  <v-card>
    <v-toolbar
      dark
      dense
      flat
    >
      <v-toolbar-title>
        <v-icon>mdi-truck</v-icon>
        {{ heDate(delivery.date) }}
      </v-toolbar-title>

    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row class="wrap">
          <v-col
            cols="12"
            md="4"
            v-if="delivery.tempStore"
          >
            <h3 class="body-2 grey--text">חנות ביניים</h3>
            <span class="title black--text">{{ storeById(delivery.tempStore) || 'ללא חנות' }}</span>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <h3 class="body-2 grey--text">סה״כ מכשירים</h3>
            <span class="title black--text">{{ deliveryItems ? deliveryItems.length : 0 }}</span>
          </v-col>
        </v-row>
      </v-container>
      <v-stepper
        :value="stepperValue"
        flat
        class="elevation-2 "
      >
        <v-stepper-header>
          <v-stepper-step
            step="1"
            :complete="stepperValue > 1"
          >
            {{ stepperValue > 1 ? 'המשלוח מוכן' : 'הכנת משלוח' }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            step="2"
            :complete="stepperValue > 2"
          >
            {{ stepperValue > 2 ? 'הועבר לשליח' : 'העברה לשליח' }}
            <!-- <small v-if="stepperValue == 2">יום שלישי, 23 במאי</small> -->
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            step="3"
            :complete="stepperValue > 3"
          >
            {{ stepperValue > 3 ? 'הגיע ליעד' : 'הגעת משלוח ליעד' }}
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import { format } from "date-fns";

export default {
  data() {
    return {
      removing: []
    };
  },
  computed: {
    deliveryItems() {
      return Object.values(this.$store.state.entities.deliveryItems)
        .filter(item => {
          return item.delivery && item.delivery === this.delivery._id;
        })
        .sort((a, b) => {
          return a.store < b.store ? -1 : 1;
        });
    },
    stepperValue() {
      return this.delivery.isDeliveredToFinalStore
        ? 4
        : this.delivery.isDeliveredToTempStore
        ? 3
        : this.delivery.isReady
        ? 2
        : 1;
    }
  },
  props: ["delivery"],
  watch: {},
  mounted() {},
  methods: {
    format,
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    },
    storeById(id) {
      if (id) {
        let store = this.$store.state.entities.stores[id];
        if (store) {
          return store.title;
        }
      }
    },
    boxTypeById(id) {
      if (id) {
        let boxType = this.$store.state.entities.boxTypes[id];
        if (boxType) {
          return boxType.title;
        }
      }
    }
  },
  components: {},
  mixins: []
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>